import React, {useCallback, useEffect, useState} from 'react';
import {Flex, GridItem} from '@chakra-ui/react';
import { StyledGrid } from "../../../../components/Styled/StyledComponents";
import { ButtonStack, CustomButton } from "../../../../components/Styled/StyledButtons";
import {Icon} from "@iconify/react";
import LeakReportSearchFilter from "./LeakReportSearchFilter";
import CsvDownloadButton from "react-json-to-csv";
import {exportLeakReports} from "../../LeakReport/LeaksAPI";
import moment from "moment/moment";

const LeakReportTableTopBar = ({  setPageNumber, setFilterOptions, setFetchTrigger }) => {
    const [exportLeak, setExportLeakReports] = useState([]);
    useEffect(() => {
        const exportData=async ()=>{
            const exportLeaks= await exportLeakReports();
            setExportLeakReports(exportLeaks)
        }
        exportData()
    }, []);

    const handleFilterChange = useCallback(async (newFilterOptions) => {
        setPageNumber(1);
        await new Promise(resolve => setTimeout(resolve, 0));
        setFilterOptions(newFilterOptions);
        setFetchTrigger(f => !f);
    }, [setPageNumber, setFilterOptions, setFetchTrigger]);

    return (
        <>
            <StyledGrid templateColumns="repeat(12, 1fr)">
                <GridItem colSpan={{ base: 10, md: 11 }}>
                    <LeakReportSearchFilter onFilterChange={handleFilterChange} />
                </GridItem>
                <GridItem colSpan={{ base: 12, md: 1 }}>
                    <ButtonStack direction="row">
                        <CsvDownloadButton children={ <CustomButton
                            type="addNew"
                            showIcon={true}
                            showTooltip={true}
                            tooltipLabel="Export csv"
                            icon={<Icon icon="ph:file-csv-light" />}

                        >
                            Export
                        </CustomButton>} data={exportLeak?exportLeak:[]} filename={`Water-Leaks-Report-${moment().format('DD-MM-YYYY')}`}/>

                    </ButtonStack>
                </GridItem>
            </StyledGrid>
            <Flex bg="white" mb={4}></Flex>
        </>
    );
};

export default LeakReportTableTopBar;
